import React from "react";
import "./TutorialOverlay.css";

export default function TutorialOverlay({ title, steps, onClose }) {
  return (
    <div className="tutorial-overlay" onClick={onClose}>
      <div className="tutorial-card" onClick={(e) => e.stopPropagation()}>
        <div className="tutorial-card__header">
          <span className="tutorial-card__title">{title}</span>
          <button className="tutorial-card__close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="tutorial-card__steps">
          {steps.map((step, i) => (
            <div key={i} className="tutorial-card__step">
              <span className="tutorial-card__step-icon">{step.icon}</span>
              <span
                className="tutorial-card__step-text"
                dangerouslySetInnerHTML={{ __html: step.text }}
              />
            </div>
          ))}
        </div>

        <button className="tutorial-card__btn" onClick={onClose}>
          Rozumiem, zaczynajmy! 🎉
        </button>
      </div>
    </div>
  );
}
